<template>
    <div class="app-container">

        <el-form :inline="true" :model="queryParams" class="search-form">
            <el-form-item label="任务名称">
                <el-input v-model="queryParams.taskname" placeholder="请输入任务名称" clearable />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button type="success" @click="handleAdd">新增任务</el-button>
            </el-form-item>
        </el-form>

        <!-- 任务列表 -->
        <el-table :data="taskList" border style="width: 100%">
            <!-- <el-table-column prop="id" label="ID" width="80" /> -->
            <el-table-column prop="taskname" label="任务名称" />
            <el-table-column prop="wechatid" label="企业微信ID" />
            <el-table-column prop="roomid" label="房间号ID" width="100" />
            <el-table-column prop="end_broad_cast_time" label="完播标识" width="100">

            </el-table-column>
            <el-table-column label="监控状态" width="120">
                <template slot-scope="{row}">
                    <el-tag type="info">
                        {{ row.statusMessage || '未校验' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="arrival_label" label="到播标签" />
            <el-table-column prop="end_broad_cast_label" label="完播标签" />
            <el-table-column prop="red_en_velope_label" label="驻留标签" />
            <el-table-column prop="task_statu" label="任务状态">
                <template #default="{ row }">
                    <el-tag :type="row.task_statu === 1 ? 'success' : 'danger'">
                        {{ row.task_statu === 1 ? '启用' : '停用' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280">
                <template #default="{ row }">
                    <el-button size="small" type="primary" @click="handleEdit(row)">编辑</el-button>
                    <el-button size="small" type="info" @click="showDataDialog(row)">查看数据</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination v-model:current-page="queryParams.pageNum" v-model:page-size="queryParams.pageSize" :total="total"
            layout="total, prev, pager, next, jumper" @current-change="handlePageChange" />

        <!-- 新增/编辑任务对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
            <el-form ref="taskForm" :model="taskForm" :rules="rules" label-width="120px">
                <el-form-item label="任务名称" prop="taskname">
                    <el-input v-model="taskForm.taskname" placeholder="请输入任务名称" />
                </el-form-item>
                <el-form-item label="企业微信ID" prop="wechatid">
                    <el-input v-model="taskForm.wechatid" placeholder="请输入企业微信ID" />
                </el-form-item>
                <el-form-item label="平台Token" prop="openapitoken">
                    <el-input v-model="taskForm.openapitoken" placeholder="请输入平台Token" />
                </el-form-item>
                <el-form-item label="房间号ID" prop="roomid">
                    <el-input v-model.number="taskForm.roomid" placeholder="请输入房间号ID" />
                </el-form-item>
                <el-form-item label="完播标识(秒)" prop="end_broad_cast_time">
                    <el-input v-model.number="taskForm.end_broad_cast_time" placeholder="请输入完播时间"></el-input>

                </el-form-item>
                <el-form-item label="到播标签" prop="arrival_label">
                    <el-input v-model="taskForm.arrival_label" placeholder="请输入到播标签" />
                </el-form-item>
                <el-form-item label="完播标签" prop="end_broad_cast_label">
                    <el-input v-model="taskForm.end_broad_cast_label" placeholder="请输入完播标签" />
                </el-form-item>
              <el-form-item label="驻留时长（秒）" prop="qjwf_token">
                <el-input v-model="taskForm.qjwf_token" placeholder="请输入驻留时长" />
              </el-form-item>
                <el-form-item label="驻留标签" prop="red_en_velope_label">
                    <el-input v-model="taskForm.red_en_velope_label" placeholder="请输入驻留标签" />
                </el-form-item>

                <el-form-item label="千家万粉UID" prop="qjwf_uid">
                    <el-input v-model="taskForm.qjwf_uid" placeholder="请输入千家万粉UID" />
                </el-form-item>
                <el-form-item label="任务状态" prop="task_statu">
                    <el-radio-group v-model="taskForm.task_statu">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </template>
        </el-dialog>

        <!-- 查看数据对话框 -->
        <el-dialog title="任务数据" :visible.sync="dataDialogVisible" width="85%">
            <el-form :inline="true" :model="dataQueryParams" class="search-form">
                <el-form-item label="微信用户名">
                    <el-input v-model="dataQueryParams.wechat_user_name" placeholder="请输入微信用户名" clearable />
                </el-form-item>
                <el-form-item label="到播状态">
                    <el-select v-model="dataQueryParams.dk_statu" placeholder="请选择" clearable>
                        <el-option label="成功" :value="1" />
                        <el-option label="失败" :value="0" />
                    </el-select>
                </el-form-item>
                <el-form-item label="完播状态">
                    <el-select v-model="dataQueryParams.wb_statu" placeholder="请选择" clearable>
                        <el-option label="成功" :value="1" />
                        <el-option label="失败" :value="0" />
                    </el-select>
                </el-form-item>
                <el-form-item label="驻留状态">
                    <el-select v-model="dataQueryParams.hb_statu" placeholder="请选择" clearable>
                        <el-option label="成功" :value="1" />
                        <el-option label="失败" :value="0" />
                    </el-select>
                </el-form-item>
                <el-form-item label="日期范围">
                    <el-date-picker v-model="dataQueryParams.dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        :default-value="[new Date(), new Date()]" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="fetchTaskData">查询</el-button>
                </el-form-item>
            </el-form>

            <el-table :data="taskDataList" border style="width: 100%">
                <el-table-column prop="wechat_user_space_id" label="微信用户ID" width="120" />
                <el-table-column prop="roomid" label="房间号" width="100" />
                <el-table-column prop="wechat_user_name" label="微信用户名" width="150" />
                <el-table-column prop="wechat_user_photo" label="微信头像" width="100">
                    <template #default="{ row }">
                        <el-image style="width: 50px; height: 50px" :src="row.wechat_user_photo"
                            :preview-src-list="[row.wechat_user_photo]" fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="stay_duration" label="停留时长(秒)" width="120" />
                <el-table-column prop="red_earnings" label="驻留时长(秒)" width="120" />
                <el-table-column prop="dk_statu" label="到播状态" width="100">
                    <template #default="{ row }">
                        <el-tag :type="row.dk_statu === 1 ? 'success' : 'danger'">
                            {{ row.dk_statu === 1 ? '成功' : '失败' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="wb_statu" label="完播状态" width="100">
                    <template #default="{ row }">
                        <el-tag :type="row.wb_statu === 1 ? 'success' : 'danger'">
                            {{ row.wb_statu === 1 ? '成功' : '失败' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="hb_statu" label="驻留状态" width="100">
                    <template #default="{ row }">
                        <el-tag :type="row.hb_statu === 1 ? 'success' : 'danger'">
                            {{ row.hb_statu === 1 ? '成功' : '失败' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="query_date" label="数据日期" width="120" />
                <el-table-column label="上报日志" width="150">
                    <template #default="{ row }">
                        <el-button type="text" @click="showMessageDialog(row)">查看日志</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination v-model:current-page="dataQueryParams.pageNum" v-model:page-size="dataQueryParams.pageSize"
                :total="dataTotal" layout="total, prev, pager, next, jumper" @current-change="handleDataPageChange" />
        </el-dialog>

        <!-- 日志详情对话框 -->
        <el-dialog title="上报日志详情" :visible.sync="messageDialogVisible" width="50%">
            <el-descriptions :column="1" border>
                <el-descriptions-item label="到播信息">{{ currentMessage.dk_message || '无' }}</el-descriptions-item>
                <el-descriptions-item label="完播信息">{{ currentMessage.wb_message || '无' }}</el-descriptions-item>
                <el-descriptions-item label="驻留信息">{{ currentMessage.hb_message || '无' }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="deleteDialogVisible" width="30%">
            <span>确定要删除该任务吗？删除后无法恢复！</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmDelete">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            deleteDialogVisible: false,
            currentDeleteId: null,
            queryParams: {
                taskname: '',
                pageNum: 1,
                pageSize: 10
            },

            // 任务列表数据
            taskList: [],
            total: 0,

            // 新增/编辑对话框相关
            dialogVisible: false,
            // dialogTitle: '',
            taskForm: {
                id: null,
                taskname: '',
                wechatid: '',
                openapitoken: '',
                roomid: null,
                end_broad_cast_time: '',
                arrival_label: '',
                end_broad_cast_label: '',
                red_en_velope_label: '',
                qjwf_token: '',
                qjwf_uid: '',
                task_statu: 1,
                uid: '' // 用户ID从后端获取
            },

            // 表单验证规则
            rules: {
                taskname: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
                wechatid: [{ required: true, message: '请输入企业微信ID', trigger: 'blur' }],
                openapitoken: [{ required: true, message: '请输入平台Token', trigger: 'blur' }],
                roomid: [
                    { required: true, message: '请输入房间号ID', trigger: 'blur' },
                    { pattern: /^[0-9]+$/, message: '房间号必须是数字', trigger: 'blur' }
                ],
                end_broad_cast_time: [{ required: true, message: '请输入完播标识', trigger: 'blur' }, { pattern: /^[0-9]+$/, message: '秒数必须是数字', trigger: 'blur' }],
                arrival_label: [{ required: true, message: '请输入到播标签', trigger: 'blur' }],
                end_broad_cast_label: [{ required: true, message: '请输入完播标签', trigger: 'blur' }],
                red_en_velope_label: [{ required: true, message: '请输入驻留标签', trigger: 'blur' }],
                qjwf_token: [{ required: true, message: '请输入驻留时长', trigger: 'blur' }],
                qjwf_uid: [{ required: true, message: '请输入千家万粉UID', trigger: 'blur' }],
                task_statu: [{ required: true, message: '请选择任务状态', trigger: 'change' }]
            },

            // 数据查询对话框相关
            dataDialogVisible: false,
            currentTaskId: null,
            taskDataList: [],
            dataTotal: 0,
            dataQueryParams: {
                wechat_user_name: '',
                dk_statu: null,
                wb_statu: null,
                hb_statu: null,
                dateRange: [new Date().toISOString().split('T')[0]], // 默认当天
                pageNum: 1,
                pageSize: 10
            },

            // 日志详情对话框相关
            messageDialogVisible: false,
            currentMessage: {
                dk_message: '',
                wb_message: '',
                hb_message: ''
            },
            generateDialog: false,
            typeMap: {
                0: '激活',
                8: '首次拉活'
            },
            searchKehu: '',
            tableData: [],
            loading: false,
            // dialogVisible: false,
            dialogTitle: '添加客户',
            form: { id: null, kehu: '', upgl: '' },
            form2: { url: '' },
            userId: null,

        }
    },
    created() {

        this.queryParams.uid = this.$route.query.userId
        this.userId = this.$route.query.userId
        if (!this.queryParams.uid) {
            this.$message.warning('您得先登录')
            setTimeout(() => {
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)
        }
        // this.loadData()
        this.fetchTaskList()
    },
    methods: {
        handleDelete(row) {
            this.currentDeleteId = row.id
            this.deleteDialogVisible = true
        },

        // 确认删除
        async confirmDelete() {
            try {
                await axios.delete(`https://control.zjwec.cn/jfmonitor/task/delete/${this.currentDeleteId}`)
                this.$message.success('删除任务成功')
                this.deleteDialogVisible = false

                this.queryParams.pageNum = 1

                this.fetchTaskList()
            } catch (error) {
                this.$message.error('删除任务失败')
                console.error('删除任务失败:', error)
            }
        },
        async fetchTaskList() {
            try {

                const response = await axios.get('https://control.zjwec.cn/jfmonitor/task/page', {
                    params: this.queryParams
                })
                this.taskList = response.data.data.records || []
                this.total = response.data.data.total || 0


                const checkPromises = this.taskList.map(task =>
                    this.checkTaskStatus(task).catch(() => ({ ...task, isValid: false }))
                );

                this.taskList = await Promise.all(checkPromises);

                console.log(this.taskList);

            } catch (error) {
                this.$message.error('获取任务列表失败')
                console.error(error)
            }
        },
        async checkTaskStatus(task) {
            try {
                const res = await axios.post(`https://control.zjwec.cn/jfmonitor/task/test`, task);

                if (res.data.code === "0") {
                    return {
                        ...task,
                        statusMessage: '校验成功',
                    };
                } else if (res.data.code === "500") {
                    return {
                        ...task,
                        statusMessage: '房间号错误',

                    };
                } else if (res.data.code === "90001") {
                    return {
                        ...task,
                        statusMessage: 'Token缺失'
                    };
                } else {
                    return {
                        ...task,
                        statusMessage: '未知错误',
                    };
                }
            } catch (error) {
                console.error('任务校验异常:', error);
                return {
                    ...task,
                    statusMessage: '请求失败',
                };
            }
        },

        // 查询任务
        handleQuery() {
            this.queryParams.pageNum = 1
            this.fetchTaskList()
        },

        // 分页变化
        handlePageChange(page) {
            this.queryParams.pageNum = page
            this.fetchTaskList()
        },

        // 新增任务
        handleAdd() {
            console.log(this.taskForm);
            this.dialogTitle = '新增任务'
            this.dialogVisible = true
            this.$refs.taskForm.clearValidate();
            Object.keys(this.taskForm).forEach(key => {
                if (key === 'end_broad_cast_time') {
                    this.taskForm[key] = 1
                } else if (key === 'task_statu') {
                    this.taskForm[key] = 1
                } else {
                    this.taskForm[key] = key === 'id' ? null : ''
                }
            })
        },

        // 编辑任务
        handleEdit(row) {
            this.dialogTitle = '编辑任务'
            this.dialogVisible = true
            // this.$refs.taskForm.clearValidate();
            Object.keys(this.taskForm).forEach(key => {
                this.taskForm[key] = row[key]
            })
        },

        // 提交表单
        async submitForm() {
            try {
                if (this.taskForm.id) {
                    // 编辑
                    await this.$refs.taskForm.validate();
                    await axios.put('https://control.zjwec.cn/jfmonitor/task/update', { ...this.taskForm, uid: this.userId })
                    this.$message.success('修改任务成功')
                } else {
                    // 新增
                    await this.$refs.taskForm.validate();
                    await axios.post('https://control.zjwec.cn/jfmonitor/task/add', { ...this.taskForm, uid: this.userId })
                    this.$message.success('新增任务成功')
                }
                this.dialogVisible = false
                this.fetchTaskList()
            } catch (error) {
                this.$message.error('操作失败')
                console.error(error)
            }
        },

        // 显示数据对话框
        showDataDialog(row) {
            console.log(row);
            this.currentTaskId = row.roomid
            this.dataQueryParams.pageNum = 1
            this.dataDialogVisible = true
            this.fetchTaskData()
        },

        // 获取任务数据
        async fetchTaskData() {
            try {
                // 准备查询参数
                const params = {
                    roomid: this.currentTaskId,
                    wechat_user_name: this.dataQueryParams.wechat_user_name,
                    dk_statu: this.dataQueryParams.dk_statu,
                    wb_statu: this.dataQueryParams.wb_statu,
                    hb_statu: this.dataQueryParams.hb_statu,
                    pageNum: this.dataQueryParams.pageNum,
                    pageSize: this.dataQueryParams.pageSize,
                    uid: this.userId
                }
                console.log(this.dataQueryParams.dateRange);
                // 处理日期范围
                if (this.dataQueryParams.dateRange && this.dataQueryParams.dateRange.length === 2) {
                    params.queryBegin = this.dataQueryParams.dateRange[0]
                    params.queryEnd = this.dataQueryParams.dateRange[1]
                } else {
                    // 默认当天
                    const today = this.formatDate(new Date())
                    params.queryBegin = today
                    params.queryEnd = today
                }

                // 调用接口
                const response = await axios.get('https://control.zjwec.cn/jfmonitor/data/page', {
                    params: params
                })
                console.log(response);
                this.taskDataList = response.data.data.records || []
                this.dataTotal = response.data.data.total || 0
            } catch (error) {
                this.$message.error('获取任务数据失败')
                console.error('获取任务数据失败:', error)
            }
        },

        // 格式化日期为 yyyy-MM-dd
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },


        // 数据分页变化
        handleDataPageChange(page) {
            this.dataQueryParams.pageNum = page
            this.fetchTaskData()
        },

        // 显示日志详情
        showMessageDialog(row) {
            this.currentMessage.dk_message = row.dk_message
            this.currentMessage.wb_message = row.wb_message
            this.currentMessage.hb_message = row.hb_message
            this.messageDialogVisible = true
        }

    },

}
</script>

<style scoped>
.app-container {
    padding: 20px;
}

.search-form {
    margin-bottom: 20px;
}

.el-pagination {
    margin-top: 20px;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/feedbackManager/feedbackmanager.vue